export default {
  4: {
    '9/19': {
      cardsPerRow: [2, 2, 2, 2],
      size: 36,
    },
    '9/16': {
      cardsPerRow: [3, 2, 3],
      size: 30,
    },
    '2/3': {
      cardsPerRow: [3, 2, 3],
      size: 30,
    },
    '3/4': {
      cardsPerRow: [3, 2, 3],
      size: 28,
    },
    '1/1': {
      cardsPerRow: [3, 2, 3],
      size: 20,
    },
    '4/3': {
      cardsPerRow: [4, 4],
      size: 20,
    },
    '3/2': {
      cardsPerRow: [4, 4],
      size: 20,
    },
    '16/9': {
      cardsPerRow: [4, 4],
      size: 19,
    },
    '19/9': {
      cardsPerRow: [4, 4],
      size: 16,
    },
    '21/9': {
      cardsPerRow: [4, 4],
      size: 12,
    },
  },
  6: {
    '9/19': {
      cardsPerRow: [3, 3, 3, 3],
      size: 32,
    },
    '9/16': {
      cardsPerRow: [3, 3, 3, 3],
      size: 30,
    },
    '2/3': {
      cardsPerRow: [3, 3, 3, 3],
      size: 26,
    },
    '3/4': {
      cardsPerRow: [3, 3, 3, 3],
      size: 20,
    },
    '1/1': {
      cardsPerRow: [4, 4, 4],
      size: 20,
    },
    '4/3': {
      cardsPerRow: [4, 4, 4],
      size: 17,
    },
    '3/2': {
      cardsPerRow: [6, 6],
      size: 16,
    },
    '16/9': {
      cardsPerRow: [6, 6],
      size: 16,
    },
    '19/9': {
      cardsPerRow: [6, 6],
      size: 16,
    },
    '21/9': {
      cardsPerRow: [6, 6],
      size: 12,
    },
  },
  8: {
    '9/19': {
      cardsPerRow: [3, 2, 3, 3, 2, 3],
      size: 24,
    },
    '9/16': {
      cardsPerRow: [4, 4, 4, 4],
      size: 20,
    },
    '2/3': {
      cardsPerRow: [4, 4, 4, 4],
      size: 24,
    },
    '3/4': {
      cardsPerRow: [4, 4, 4, 4],
      size: 20,
    },
    '1/1': {
      cardsPerRow: [5, 6, 5],
      size: 16,
    },
    '4/3': {
      cardsPerRow: [5, 6, 5],
      size: 16,
    },
    '3/2': {
      cardsPerRow: [5, 6, 5],
      size: 15,
    },
    '16/9': {
      cardsPerRow: [5, 6, 5],
      size: 12,
    },
    '19/9': {
      cardsPerRow: [8, 8],
      size: 12,
    },
    '21/9': {
      cardsPerRow: [8, 8],
      size: 12,
    },
  },
};
